import { CommStatus } from "../../../../../../../services/api-client/contact-api.types";
import { AppointmentStatus, AppointmentStatusText, PatientAppointment } from "../../../../../../../services/appointment/types";
import { ErrorStatus, StandardStatus, SuccessStatus } from "../../../patient-profile-widget.styles";

export const getApptStatus = (appt: PatientAppointment) => {
  switch (appt.status) {
    case AppointmentStatus.Confirmed:
      return <SuccessStatus>{AppointmentStatusText[appt.status]}</SuccessStatus>;
      case AppointmentStatus.Cancelled:
      case AppointmentStatus.Deleted:
      return <ErrorStatus>{AppointmentStatusText[appt.status]}</ErrorStatus>;
    default:
      return <StandardStatus>{AppointmentStatusText[appt.status]}</StandardStatus>
  }
};